import { render, staticRenderFns } from "./Escrow.vue?vue&type=template&id=a94940d4"
import script from "./Escrow.vue?vue&type=script&lang=js"
export * from "./Escrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports